<div *ngIf="_vehicle" class="vehicle-details-tabs" id="vehicle-details-tabs" [style.top.px]="topPosition">

    <div class="line-upper"></div>

    <div class="tabs">

        <div class="params-tab tab" (click)="selectTab('params')" [ngClass]="{'selected': tab === 'params' }">
          {{'vehicle-details-tabs.parameters' | translate}}
        </div>

        <div *ngIf="isRoutesEnabled" class="routes-tab tab" (click)="selectTab('routes')"
             [ngClass]="{'selected': tab === 'routes' }">
          {{'vehicle-details-tabs.routes' | translate}}
        </div>

        <div class="tacho-tab tab" (click)="selectTab('tacho')" [ngClass]="{'selected': tab === 'tacho' }">
          {{'vehicle-details-tabs.tacho' | translate}}
        </div>

        <div *ngIf="isETollEnabled" class="e-toll-tab tab" (click)="selectTab('e-toll')"
            [ngClass]="{'selected': tab === 'e-toll' }">
          {{'vehicle-details-tabs.etoll' | translate}}
        </div>

        <div *ngIf="isVisibleSent" class="sent-tab tab" (click)="selectTab('sent')"
            [ngClass]="{'selected': tab === 'sent' }">
          {{'Sent' | translate}}
        </div>

        <div *ngIf="isVisibleBlockTab" class="e-toll-tab tab" (click)="selectTab('blocked')" [ngClass]="{'selected': tab === 'blocked' }">
          {{'blocked'|translate}}
        </div>
    </div>

    <div class="line-bottom"></div>

    <div id="tab-content" class="content">

        <div *ngIf="tab === 'params'" [ngClass]="{'selected': tab === 'params' }">
            <tk-vehicle-details-params-tab [vehicle]="_vehicle"></tk-vehicle-details-params-tab>
        </div>

        <div *ngIf="tab === 'routes' && isRoutesEnabled" [ngClass]="{'selected': tab === 'routes' }" class="routes-content">
            <tk-vehicle-details-routes-tab [vehicleId]="_vehicle.Id"></tk-vehicle-details-routes-tab>
        </div>

        <!-- <div *ngIf="tab === 'eco'" [ngClass]="{'selected': tab === 'eco' }">
            <tk-vehicle-details-eco-tab [vehicle]="vehicle"></tk-vehicle-details-eco-tab>
        </div> -->

        <div *ngIf="tab === 'tacho'" [ngClass]="{'selected': tab === 'tacho' }">
            <tk-vehicle-details-tacho-tab [item]="_vehicle"></tk-vehicle-details-tacho-tab>
        </div>

        <div *ngIf="tab === 'e-toll' && isETollEnabled" [ngClass]="{'selected': tab === 'e-toll' }">
            <tk-vehicle-details-e-toll-tab [vehicle]="_vehicle"></tk-vehicle-details-e-toll-tab>
        </div>

        <div *ngIf="tab === 'blocked'" [ngClass]="{'selected': tab === 'blocked' }" class="blocked-content">
            <app-th-vehicle-details-locks-tab [vehicle]="_vehicle"></app-th-vehicle-details-locks-tab>
        </div>

        <div *ngIf="tab === 'sent'" [ngClass]="{'selected': tab === 'sent' }" class="sent-content">
            <app-sent-tab [vehicleData]="_vehicle"></app-sent-tab>
        </div>
    </div>
</div>
